import type { MantleMode } from '~/types/leData';

export const NEW_SESSION_MODE: MantleMode = 'standard';

export type ShellRequestKind = 'draft' | 'new-chat';
